import { gatewayInstance } from "../../axiosInstance";

const BASE_FINANCE = "/financeservice";
const SUPPLIER_PAYMENT_HOLD_BASE = `${BASE_FINANCE}/supplier-payment-hold`;

const handleApiError = (error, contextMsg = "API Error") => {
    console.error(`[SupplierPaymentHold API] ${contextMsg}:`, error?.response?.data || error.message || error);
    throw error;
};

export const addSupplierPaymentHoldData = async ({
                                                     supplierPaymentHoldRequest,
                                                     author,
                                                 }) => {
    try {
        const response = await gatewayInstance.post(SUPPLIER_PAYMENT_HOLD_BASE, {
            ...supplierPaymentHoldRequest,
            author,
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to save Payment Hold");
    }
};

export const getSupplierPaymentHoldList = async (searchRequest = {}) => {
    try {
        const response = await gatewayInstance.post(
            `${SUPPLIER_PAYMENT_HOLD_BASE}/search`,
            searchRequest
        );
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to search Payment Holds");
    }
};

export const unholdSupplierPaymentHold = async ({ sphIds, author }) => {
    try {
        const response = await gatewayInstance.put(
            `${SUPPLIER_PAYMENT_HOLD_BASE}/unhold`,
            { sphIds, author }
        );
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to unhold Payment Hold");
    }
};

export const getSupplierPaymentHoldSuppliers = async ({
                                                          evInvType,
                                                          company,
                                                          searchText
                                                      }) => {
    try {
        const response = await gatewayInstance.get(
            `${SUPPLIER_PAYMENT_HOLD_BASE}/suppliers`,
            { params: { evInvType, company, searchText } }
        );
        return response.data.map((item) => ({
            key: item.stkId,
            value: item.stkId,
            text: item.stkName,
            title: item.stkName
        }));
    } catch (error) {
        return handleApiError(error, "Failed to fetch supplier options");
    }
};

export const getSupplierPaymentHoldJobs = async ({ evInvType, company, searchText }) => {
    try {
        const response = await gatewayInstance.get(
            `${SUPPLIER_PAYMENT_HOLD_BASE}/jobs`,
            { params: { evInvType, company, searchText } }
        );
        return response.data.map((item) => ({
            key: item.jobId,
            value: item.jobId,
            text: item.jobDisplay,
            title: item.jobDisplay
        }));
    } catch (error) {
        return handleApiError(error, "Failed to fetch job options");
    }
};

export const checkSupplierPaymentHold = async ({
                                                   evInvType,
                                                   jobIds = [],
                                                   supplierIds = [],
                                               }) => {
    try {
        const response = await gatewayInstance.post(
            `${SUPPLIER_PAYMENT_HOLD_BASE}/check-hold`,
            { evInvType, jobIds, supplierIds }
        );
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to check payment hold status");
    }
};